import { useState } from "react"

export function useLaunchHandlers(refetchAccount: () => void) {
  const [launchSuccess, setLaunchSuccess] = useState(false)
  const [launchError, setLaunchError] = useState(false)
  const [getCompanyError, setGetCompanyError] = useState(false)
  const [launchedCompanies, setLaunchedCompanies] = useState<{ id: number; name: string }[]>([])

  const handleLaunchSuccess = (companies: { id: number; name: string }[]) => {
    setLaunchSuccess(true)
    setLaunchedCompanies(companies)
    setLaunchError(false)
    setGetCompanyError(false)
    refetchAccount()
  }

  const handleLaunchError = () => {
    setLaunchError(true)
    setLaunchSuccess(false)
  }

  const handleGetCompanyError = () => {
    setGetCompanyError(true)
  }

  return {
    launchSuccess,
    launchError,
    getCompanyError,
    launchedCompanies,
    handleLaunchSuccess,
    handleLaunchError,
    handleGetCompanyError
  }
}
